import React, { useRef } from 'react';

import notie from 'notie'

import './Contact.css';

function Contact() {
    const formRef = useRef(null);

    const handleSubmit = (e) => {
        e.preventDefault();
        let myForm = formRef.current;
        let formData = new FormData(myForm)
        fetch('/', {
            method: 'POST',
            headers: { "Content-Type": "application/x-www-form-urlencoded" },
            body: new URLSearchParams(formData).toString()
        }).then(() => {
            notie.alert({
                type: "success",
                text: "Form submitted, I'll be in touch soon!",
                stay: false,
                time: 5,
                position: "top"
            });
            myForm.reset();
        }).catch(() => {
            notie.alert({
                type: "warning", // optional, default = 4, enum: [1, 2, 3, 4, 5, 'success', 'warning', 'error', 'info', 'neutral']
                text: "Failed to submit form, something went wrong. Please try again later.",
                stay: false, // optional, default = false
                time: 5, // optional, default = 3, minimum = 1,
                position: "top" // optional, default = 'top', enum: ['top', 'bottom']
            });
        });
    }

    return (
        <div className="container" style={{ paddingTop: '10%' }}>
            <div className="row">
                <div className="spacer"></div>
                <div className="col col-12 col-expand">
                    <h1 className="display-4 text-bold text-indigo">Contact</h1>
                    <p>Reach out about software consulting, product engineering, technical planning, or a focused review of an existing application. You can also email me directly at <a href="mailto:omar@quazi.co?Subject=Project+Enquiry">omar@quazi.co</a>.</p>

                    <form id="contactForm" name="contact" className="form-modern" method="POST" data-netlify="true" data-netlify-honeypot="bot-field" onSubmit={handleSubmit} ref={formRef}>
                        <input type="hidden" name="form-name" value="contact" />
                        <p className="visually-hidden" aria-hidden="true">
                            <label>Do not fill this out if you are human: <input name="bot-field" tabIndex={-1} autoComplete="off" /></label>
                        </p>

                        <div className="contact-form-grid">
                            <label htmlFor="contact-name">Name</label>
                            <input id="contact-name" type="text" name="name" placeholder="Jane Doe" required />

                            <label htmlFor="contact-requirement">Reason for reaching out</label>
                            <select id="contact-requirement" name="requirement[]" required defaultValue="">
                                <option value="" disabled>Select one</option>
                                <option value="app">Build or improve an app</option>
                                <option value="website">Build or improve a website</option>
                                <option value="bug">Debug an existing issue</option>
                                <option value="consultant">Discuss technical strategy</option>
                            </select>

                            <label htmlFor="contact-email">Email</label>
                            <input id="contact-email" type="email" name="email" placeholder="Your email" required />
                        </div>
                        <p>
                            <button className="btn btn-indigo" type="submit">Send Enquiry &#8594;</button>
                        </p>
                    </form>
                </div>
            </div>
            <div className="spacer"></div>
            <div className="row">
                <div className="col col-12 col-expand">
                    <h2 className="display-4 text-bold text-indigo">
                        Frequently Asked Questions</h2>
                    <details>
                        <summary>What kind of work do you take on?</summary>
                        I usually help with application development, backend/API work, technical planning, debugging, reliability improvements, and focused product engineering support.
                    </details>

                    <details>
                        <summary>How do you structure project pricing?</summary>
                        Pricing depends on scope, urgency, and the amount of ambiguity involved. Smaller engagements can be fixed-scope; larger builds are usually milestone-based so expectations stay clear.
                    </details>

                    <details>
                        <summary>How long does a typical project take?</summary>
                        A focused review or bug fix may take a few days. A small site or feature build often takes a few weeks. More involved product or backend work should be planned in milestones.
                    </details>

                    <details>
                        <summary>What technologies do you work with?</summary>
                        My recent work centers on TypeScript, Node.js, React, React Native, APIs, authentication, cloud services, databases, and operational tooling.
                    </details>

                    <details>
                        <summary>Can you work with an existing codebase?</summary>
                        Yes. I can review the current architecture, identify risks, fix defects, improve maintainability, or help plan a path from a messy system to something easier to operate.
                    </details>

                    <details>
                        <summary>Do you outsource work?</summary>
                        No. If I take on the engagement, the technical work is handled directly by me.
                    </details>

                    <details>
                        <summary>What is the best way to start?</summary>
                        Send a short note with the goal, current state, timeline, and any relevant links. I will respond with the next useful step, whether that is a quick call, a written estimate, or a scoped technical review.
                    </details>

                </div>
            </div>
            <div className="spacer"></div>
        </div>
    )
}

export default Contact
